import React, { useState, useCallback } from "react";
import { CountUp } from "use-count-up";
import axios from "axios";
import { Checkbox } from "antd";
import { If, Then } from "react-if";
import { comma } from "../Func.js";
import { floor } from "lodash";

function StakingModal({
  refreshPage,
  address,
  profitData,
  userInfo,
  creta,
  setLoading,
  setStakingModalOpen,
}) {
  const tronweb = window.tronWeb;

  const [selectedPkg, setSelectedPkg] = useState(null);
  const [stakingCretaAmount, setStakingCretaAmount] = useState("");

  const packages = [
    { pkg: "90 DAYS", percent: 8, day: 90 },
    { pkg: "180 DAYS", percent: 12, day: 180 },
    { pkg: "365 DAYS", percent: 15, day: 365 },
  ];

  const onChangeTerm = useCallback((e) => {
    setTerm(e.target.checked);
  }, []);
  const onChangeTerm2 = useCallback((e) => {
    setTerm2(e.target.checked);
  }, []);

  const [term, setTerm] = useState(false);
  const [term2, setTerm2] = useState(false);

  const onChangeStakingCreta = (e) => {
    const { value, maxLength } = e.target;
    const message = value.slice(0, maxLength);

    setStakingCretaAmount(message);
  };

  const setStakingCretaAmountByPercent = (percent) => {
    setStakingCretaAmount(floor((percent / 100) * creta));
  };

  async function cretaStakingRequest() {
    if (stakingCretaAmount === "") {
      alert("Please enter the amount.");
      return;
    }

    if (+stakingCretaAmount > +creta) {
      alert("You have exceeded the staking amount.");
      return;
    }

    if (+stakingCretaAmount < 1000) {
      alert(
        "There is an error in the amount requested for staking (Min amount >= 1000 CRETA)"
      );
      return;
    }

    if (+stakingCretaAmount !== Math.ceil(stakingCretaAmount)) {
      alert("Please enter the quantity without decimal.");
      return;
    }

    if (!selectedPkg) {
      alert("Choose your package.");
      return;
    }

    if (!term || !term2) {
      alert("Please accept the terms and conditions.");
      return;
    }

    const message = Math.random().toString(24).substring(3, 24);
    const signature = await tronweb.trx.sign(tronweb.toHex(message));

    setLoading(true);
    try {
      axios
        .post("api/cretaStakingRequest", {
          address: address,
          creta_amount: +stakingCretaAmount,
          staking_days: selectedPkg.day,
          signature: signature,
          message: message,
        })
        .then((res) => {
          alert("The staking request has been completed");
          setStakingCretaAmount("");
          setStakingModalOpen(false);
          refreshPage();
        })
        .catch((err) => {
          if (err.response) {
            console.log(err.response);
            console.log(err.response.data.message);
            alert(err.response.data.message);
          }
          setStakingCretaAmount("");
          setLoading(false);
          // refreshPage();
        });
    } catch (err) {
      alert(err);
      setLoading(false);
      //TODO history.push('/');
    }
  }

  function selectPkg(pkg) {
    setSelectedPkg(pkg);
  }

  const CountUpValue = (amount) => {
    if (amount === undefined || amount === 0 || amount === null) {
      return <CountUp end={0} thousandsSeparator="," />;
    } else {
      return (
        <CountUp isCounting start={0} end={amount} thousandsSeparator="," />
      );
    }
  };

  return (
    <div className="modal-body">
      <h2 className="mb-3">Staking CRETA</h2>

      <div className="profit-header">
        <p className="profit-name">Balance of CRETA</p>
        <span className="profit-data profit-data-flxd">
          {" "}
          {CountUpValue(creta)}{" "}
        </span>
      </div>

      <h3>1. Enter the amount</h3>
      <p className="fee-text text-left mb-1">Minimum amount is 1,000 CRETA</p>
      <div>
        <input
          type="number"
          min="0"
          max={creta}
          value={stakingCretaAmount}
          placeholder="Amount"
          onChange={onChangeStakingCreta}
          maxLength={8}
        />
        <div className="flex-right mt-1">
          <button
            className="btn btn-sm btn-dark btn-shadow"
            onClick={() => setStakingCretaAmountByPercent(30)}
          >
            30%
          </button>
          <button
            className="btn btn-sm btn-dark btn-shadow ml-1"
            onClick={() => setStakingCretaAmountByPercent(50)}
          >
            50%
          </button>
          <button
            className="btn btn-sm btn-dark btn-shadow ml-1"
            onClick={() => setStakingCretaAmountByPercent(100)}
          >
            100%
          </button>
        </div>
      </div>

      <h3 className="mt-3">2. Select a package</h3>
      <div className="flex-center">
        {packages.map((pkg, index) => (
          <div
            key={index}
            className={`button1 color${pkg.day} ${
              selectedPkg?.pkg === pkg.pkg ? "selected" : ""
            }`}
            onClick={() => selectPkg(pkg)}
          >
            <div className="pkg">{comma(pkg.pkg)}</div>

            <div className="percent">
              <strong>{pkg.percent}%</strong>/year
            </div>
          </div>
        ))}
      </div>

      <If condition={selectedPkg}>
        <Then>
          <div className="flex-center mt-3">
            Forcasted Interest
            <hr className="thin" />
            <div className="interest">
              <strong>
                +
                {comma(
                  Math.round(
                    ((((stakingCretaAmount * selectedPkg?.day) / 365) *
                      selectedPkg?.percent) /
                      100) *
                      10
                  ) / 10
                )}
              </strong>{" "}
              CRETA
            </div>
          </div>
        </Then>
      </If>

      <div className="checkT mt-3">
        <h3 className="caution2">
          3. You can cancel your staking before expiration, but you won't
          receive any interest.
        </h3>
        <div className="caution">
          <Checkbox
            className="user-term"
            checked={term}
            onChange={onChangeTerm}
          >
            {" "}
            Agree
          </Checkbox>
        </div>
      </div>
      <div className="checkT mt-1">
        <h3 className="caution2">
          4. You can collect the staked amount and interest after the Staking
          period is over.
        </h3>
        <div className="caution">
          <Checkbox
            className="user-term"
            checked={term2}
            onChange={onChangeTerm2}
          >
            {" "}
            Agree
          </Checkbox>
        </div>
      </div>

      <hr />
      <div className="flex-space-between mt-1">
        <button
          className="btn btn-md btn-secondary"
          onClick={() => setStakingModalOpen(false)}
        >
          close
        </button>
        <button
          className="btn btn-md btn-primary"
          onClick={() => cretaStakingRequest()}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}

export default StakingModal;
